import EventService from "@/services/EventService";
import { indexById } from "@/components/Utils";

export const namespaced = true;


export const state = {
    groups: [],
    byId: {}
};

export const mutations = {
    SET_GROUPS(state, items) {
        state.groups = items;
    },
    SET_BYID(state, indexed) {
        state.byId = indexed;
    }
};

export const actions = {
    async fetchGroups(context) {
        return EventService.getGroups()
            .then(response => {
                context.commit('SET_GROUPS', response.data);
                context.commit('SET_BYID', indexById(response.data));
            })
            .catch(error => {
               console.log('getGroups failed: ', error.message)
            });
    }
};

export const getters = {
    allGroups(state) {
        return state.groups;
    },
};